import { useActiveView } from "@/hooks/useActiveView";
import { useHomeLocation } from "@/hooks/useHomeLocation";
import { useProjectsOfView } from "@/hooks/useProjectsOfView";

import { TProject } from "@/types";

/**
 * The project the home page is filtered on (`?project=`), looked up in
 * the active view's projects. A project of another view, or an
 * unknown id, is no filter at all.
 */
export const useActiveProject = (): {
	project: TProject | undefined;
	isUnknown: boolean;
	isLoading: boolean;
} => {
	const { view } = useActiveView();
	const { projectId } = useHomeLocation();
	const { projects, isLoading } = useProjectsOfView(
		projectId ? view?.id : undefined
	);
	const project = projectId
		? projects.find((p) => p.id === projectId)
		: undefined;
	return {
		project,
		isUnknown: !!projectId && !!view && !isLoading && !project,
		isLoading: !!projectId && isLoading,
	};
};
